export const COLUMNS = [
  { id: 'name', label: 'Название', minWidth: 450 },
  {
    id: 'population',
    label: 'Действия',
    minWidth: 50,
  },
];
